import axios from "axios";


const url=process.env.REACT_APP_BASE_URL


export const getAllRequest=async(setIsLoading,setData,handleAlertOpen,status)=>{
    try{
        setIsLoading(true);
        await axios.get(`${url}/ds_wallet/request_csp_mapping_list`,{
            headers:
            {
                'Authorization': `Bearer ${sessionStorage.getItem('token')}`,
                'Content-Type': 'application/json'
            },
            params:{
                status:status
            }
        })
        .then((res)=>{
            setIsLoading(false);
            setData(res.data);
        })
    }
    catch(error){
        setIsLoading(false)
        handleAlertOpen(error.response?error.response.data.error:"something went wrong","error")
    }
}

export const getAllHardwareRequest=async(setIsLoading,setData,handleAlertOpen,status)=>{
    try{
        setIsLoading(true);
        await axios.get(`${url}/ds_wallet/request_hardware_mapping_list`,{
            headers:
            {
                'Authorization': `Bearer ${sessionStorage.getItem('token')}`,
                'Content-Type': 'application/json'
            },
            params:{
                status:status
            }
        })
        .then((res)=>{
            setIsLoading(false);
            setData(res.data);
        })
    }
    catch(error){
        setIsLoading(false)
        handleAlertOpen(error.response?error.response.data.error:"something went wrong","error")
    }
}


export const getAllUnmappedCsp=async(data,setIsLoading,setData,handleErrorOpen)=>{
    try{
        setIsLoading(true);
        return await axios.post(`${url}/ds_wallet/unmapped_agent_list`,{
            request_id:data.request_id,
            ds_id:data.ds_id,
            page:1,
            page_size:100
        },{headers:
            {
                'Authorization': `Bearer ${sessionStorage.getItem('token')}`,
                'Content-Type': 'application/json'
            }
        })
        .then((res)=>{

            setData(res.data);
            setIsLoading(false);
        })
    }
    catch(error){
        setIsLoading(false);
        handleErrorOpen(error.response?error.response.data.error:"Something went wrong","error")
    }
}

export const getHardwareDetails=async(data,setIsLoading,setData,handleErrorOpen)=>{
    try{
        setIsLoading(true);
        return await axios.post(`${url}/ds_wallet/hardware_request_details`,{
            request_id:data.request_id,

        },{headers:
            {
                'Authorization': `Bearer ${sessionStorage.getItem('token')}`,
                'Content-Type': 'application/json'
            }
        })
        .then((res)=>{
            setData(res.data);
            setIsLoading(false);
        })
    }
    catch(error){
        handleErrorOpen(error.response?error.response.data.error:"Something went wrong")
    }
}

export const postShUpdatedAmount=async(data,setIsLoading,handleErrorOpen)=>{
    try{
        setIsLoading(true);
        await axios.post(`${url}/ds_wallet/csp_mapping_sh_requested_amount`,data,{
            headers:
            {
                'Authorization': `Bearer ${sessionStorage.getItem('token')}`,
                'Content-Type': 'application/json'
            }
        })
        .then((res)=>{
            setIsLoading(false);
            handleErrorOpen(res.data.message,"success")
            setTimeout(()=>{
                window.location.reload();
            },1500)
        })
    }
    catch(error){
        setIsLoading(false);
        handleErrorOpen(error.response?error.response.data.error:"Something went wrong","error")
    }
}

export const PostRmUpdatedAmount=async(data,setIsLoading,handleErrorOpen) => {
    try{
        setIsLoading(true);
        await axios.post(`${url}/ds_wallet/csp_mapping_rm_requested_amount`,data,{
            headers:
            {
                'Authorization': `Bearer ${sessionStorage.getItem('token')}`,
                'Content-Type': 'application/json'
            }
        })
        .then((res)=>{
            setIsLoading(false);
            handleErrorOpen(res.data.message,"success")
            setTimeout(()=>{
                window.location.reload();
            },1500)
        })
    }
    catch(error){
        setIsLoading(false);
        handleErrorOpen(error.response?error.response.data.error:"Something went wrong","error")
    }
}



export const getAgentDetails=async(request_id,setData,setisLoading)=>{
    try{
        setisLoading(true);
        await axios.post(`${url}/ds_wallet/csp_mapping_request_details`,{request_id:request_id},{
            headers:
            {
                'Authorization': `Bearer ${sessionStorage.getItem('token')}`,
                'Content-Type': 'application/json'
            }
        })

        .then((res)=>{
            setisLoading(false);
            setData(res.data);
        })
    }
    catch(error){
        setisLoading(false);
        console.log(error)
        console.clear()

    }
}